// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docs-menu-scope-title {
  text-indent: 0.5em;
  padding-top: 1em;
}

.search-bar {
  background-color: var(--color-background);
  color: var(--color-text);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Docs/router/screens/Index/components/DocsMenuScopeGroup.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B","sourcesContent":[".docs-menu-scope-title {\n  text-indent: 0.5em;\n  padding-top: 1em;\n}\n\n.search-bar {\n  background-color: var(--color-background);\n  color: var(--color-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
